/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {AfterContentChecked, Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WizardStepComponent} from '../../../shared/wizard/wizard-step.component';
import {WizardStepModel} from '../../../shared/wizard/wizard-step.model';
import {WizardService} from '../../../shared/wizard/wizard.service';
import {WizardIconEnum} from '../../../shared/wizard/wizard-icon.enum';
import {StepPositionDetailMaterialModel} from '../step-position-detail/step-position-detail-material.model';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {FileSummaryModel} from '../../../api/ms-filemanager/contracts/file-summary.model';

@Component({
    selector: 'app-step-confirm-send',
    templateUrl: './step-confirm-send.component.html',
    styleUrls: ['./step-confirm-send.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepConfirmSendComponent extends WizardStepComponent implements OnInit, OnDestroy, AfterContentChecked {
    @Input() stepIndex: number;
    stepModel = {
        canSave: true,
        canSend: false,
        data: [],
        icon: WizardIconEnum.NONE,
    } as WizardStepModel;
    public material: StepPositionDetailMaterialModel;
    private subscriptions = new Subscription();

    constructor(protected wizardService: WizardService) {
        super(wizardService);
        wizardService.observable
                .pipe(filter(step => step.index === 0
                        && step.data != null
                        && !this.isDeepEmpty(step.data.material)))
                .subscribe(value => {
                    this.material = value.data.material;
                });
    }

    get informationStep(): WizardStepModel {
        return this.wizardService.steps.get(0);
    }

    get positionDetailStep(): WizardStepModel {
        return this.wizardService.steps.get(1);
    }

    get attachments(): FileSummaryModel[] {
        if (this.informationStep.data != null) {
            return this.informationStep.data.attachments;
        }
    }

    get directory(): string {
        if (this.informationStep.data != null) {
            return this.informationStep.data.attachmentDirectory;
        }
    }

    get requiredAttachments(): boolean {
        if (this.informationStep.data != null
                && this.informationStep.data.claimCode != null) {
            return this.informationStep.data.claimCode.requiresAttachments;
        }
    }

    ngAfterContentChecked(): void {
        this.sendUpdateForm();
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions.add(
                this.wizardService.observable.subscribe(() => {
                    this.stepModel.canSend = this.informationStep.canSend && this.positionDetailStep.canSend;

                    if ([this.informationStep.icon, this.positionDetailStep.icon].includes(WizardIconEnum.ERROR)) {
                        this.stepModel.icon = WizardIconEnum.ERROR;
                    } else if ([this.informationStep.icon, this.positionDetailStep.icon].includes(WizardIconEnum.WARNING)) {
                        this.stepModel.icon = WizardIconEnum.WARNING;
                    } else {
                        this.stepModel.icon = WizardIconEnum.SUCCESS;
                    }

                }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

}
